import moment from 'moment';

const getDates = (dateRange) => {
    let start = moment()
    let end = moment()

    if (dateRange == 'today') {
        start = start.startOf('day')
        end = end.endOf('day')
    } 
    else if (dateRange == 'week') {
        start = start.subtract(1, 'weeks')
    } 
    else if (dateRange == 'this_month') {
        start = start.startOf('month')
        end = end.endOf('month')
    } 
    else if (dateRange == 'prev_month') {
        start = start.subtract(1, 'months')
        end = end.subtract(1, 'months')
        start = start.startOf('month')
        end = end.endOf('month')
    } 
    else if (dateRange == 'this_quarter') {
        start = start.startOf('quarter')
        end = end.endOf('quarter')
    } 
    else if (dateRange == 'prev_quarter') {
        start = start.subtract(1, 'quarter')
        end = end.subtract(1, 'quarter')
        start = start.startOf('quarter')
        end = end.endOf('quarter')
    } 
    else if (dateRange == 'this_year') {
        start = start.startOf('year')
        end = end.endOf('year')
    } 
    else if (dateRange == 'prev_year') {
        start = start.subtract(1, 'year')
        end = end.subtract(1, 'year')
        start = start.startOf('year')
        end = end.endOf('year')
    } 
    else if (dateRange == 'all') {
        start = moment('1999-01-01')
    } 
    else if (dateRange == 'custom') {
        return {}
    } else {
        return {}
    }

    return [start.toDate(), end.toDate()]
}

const getComponentControlDatePart = (value) => {
    if (typeof value !== 'string') {
        return null
    }

    // Component Control dates are calendar dates, not timezone-aware instants.
    // Preserve the date portion exactly as the backend sent it.
    const match = value.match(/^(\d{4}-\d{2}-\d{2})/)
    return match ? match[1] : null
}

const formatDateToUS = (dateString) => {
    if (!dateString) {
        return '';
    }
    
    const date = new Date(dateString);
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${year}-${month}-${day}`;
}

const formatCalendarDateToUS = (value) => {
    if (!value) {
        return ''
    }

    if (typeof value === 'string') {
        const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/)
        if (match) {
            const [, year, month, day] = match
            return `${month}/${day}/${year}`
        }
    }

    if (value instanceof Date && !Number.isNaN(value.getTime())) {
        const month = String(value.getMonth() + 1).padStart(2, '0')
        const day = String(value.getDate()).padStart(2, '0')
        const year = value.getFullYear()
        return `${month}/${day}/${year}`
    }

    return String(value)
}

const formatComponentControlDate = (dateString) => {
    // Keep blank API values blank in the table instead of showing "Invalid Date".
    if (!dateString) {
        return ''
    }

    // Do not apply timezone conversion to Component Control dates.
    const datePart = getComponentControlDatePart(dateString)
    if (datePart) {
        return datePart
    }

    const date = dateString instanceof Date ? dateString : new Date(dateString)
    // Fall back to the raw value if the input is not parseable as a datetime.
    if (Number.isNaN(date.getTime())) {
        return String(dateString)
    }

    return date.toISOString().split('T')[0]
}

const isIsoDateTime = (value) => {
    if (value instanceof Date) {
        return true
    }
    if (typeof value !== 'string') {
        return false
    }
    return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|\+\d{2}:\d{2})$/.test(value)
}

const formatIsoDate = (value) => {
    const date = value instanceof Date ? value : new Date(value)
    if (Number.isNaN(date.getTime())) {
        return String(value ?? '')
    }
    return date.toISOString().split('T')[0]
}

export {
    formatIsoDate,
    formatCalendarDateToUS,
    formatComponentControlDate,
    getDates,
    formatDateToUS,
    isIsoDateTime,
}
